<template>
  <v-card>
    <v-img
      class="white--text align-end"
      height="200px"
      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
      :contain="!hasImage"
      :src="imageUrl">
      <v-card-title>{{ value.name }}</v-card-title>
    </v-img>
    <v-card-actions>
      <v-btn
        color="primary"
        text
        style="text-transform: none"
      >
        Preview
      </v-btn>

      <v-btn
        color="primary"
        text
        style="text-transform: none"
        :to="{ name: 'sportsbooks.edit', params: { id: value.id }}"
      >
        Edit
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import get from 'lodash/get'
import has from 'lodash/has'
import isNull from 'lodash/isNull'

export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    imageUrl () {
      if (this.hasImage) {
        return get(this.value, 'banner_logo.thumb_url')
      }
      return require('@/assets/images/no-image.png')
    },
    hasImage () {
      return has(this.value, 'banner_logo.thumb_url') && !isNull(get(this.value, 'banner_logo.thumb_url'))
    }
  }
}
</script>
